import {useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLazyLoginQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader, setUserData } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useLoginApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [login] = useLazyLoginQuery();
  const getAccount = useGetAccountApi();
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  const send = (data) => {
    dispatch(setLoader(true));
    console.log('getAccount.get()1')
    login(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        localStorage.setItem("techsbook_customer_portal_token", res?.token);
        dispatch(setUserData(res?.account));
        console.log('getAccount.get()2')
        getAccount.get()
        if (accountIndex?.registration_completed) {
          showToast(res?.message ?? "Success Login", "success");
          navigate("/");
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };

  return {
    send,
  };
};

export default useLoginApi;
